export function uniquePackageAgents(packages = []) {
  const agents = new Map();
  packages.forEach((pkg) => {
    const id = pkg?.partner_id;
    const name = String(pkg?.partner_name || '').trim();
    if (id == null || !name) return;
    if (!agents.has(id)) {
      agents.set(id, {
        id,
        name,
        logoUrl: pkg.partner_logo || null,
      });
    }
  });
  return [...agents.values()].sort((left, right) => left.name.localeCompare(right.name));
}

export function filterPackagesByAgent(packages = [], agentId) {
  if (agentId == null || agentId === '') return packages;
  return packages.filter((pkg) => String(pkg.partner_id) === String(agentId));
}

export function getPartnerPackagesListingPath(partnerId) {
  const params = new URLSearchParams({ tab: 'packages' });
  if (partnerId != null && partnerId !== '') {
    params.set('agent', String(partnerId));
  }
  return `/deals?${params.toString()}`;
}
